import { AnyAction, combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  PURGE,
  REGISTER,
  REHYDRATE,
  persistStore,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import currentPreferencesSlice, {
  currentPrefsInitialState,
} from "./currentPreferencesSlice";
import loginSlice, { loginInitialState } from "./loginSlice";
import toastSlice, { toastInitialState } from "./toastSlice";
import { userNoteInitialState, userNotesSlice } from "./userNotesSlice";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
  blacklist: ["currentPreferences"],
};

const rootInitialState = {
  login: loginInitialState,
  toast: toastInitialState,
  currentPreferences: currentPrefsInitialState,
  userNotesSlice: userNoteInitialState,
};

const combinedReducer = combineReducers({
  login: loginSlice.reducer,
  toast: toastSlice.reducer,
  currentPreferences: currentPreferencesSlice.reducer,
  userNotesSlice: userNotesSlice.reducer,
});

const rootReducer = (state: any, action: AnyAction) => {
  if (action.type === "RESET") {
    state = rootInitialState;
    return state;
  }
  return combinedReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }), //.concat(logger), //only for dev purpose if you need store logs.
});

export const persistor = persistStore(store);
export default store;
